// EVENTS.VIEWS.APP.REWARDS.EARN

export const EARN = {
  PAGE_VISITED: 'earn-page_visited'
};
